package dk.smark.demo.map

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableIntStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import dk.smark.demo.ui.ZoomButtons

@Composable
expect fun OsmMap(
    controller: MapController,
    modifier: Modifier = Modifier,
    onEvent: (MapEvent) -> Unit = {}
)

@Composable
fun OsmMapShared(
    controller: MapController,
    modifier: Modifier,
    onEvent: (MapEvent) -> Unit,
) {
    var currentZoom by remember { mutableIntStateOf(16) }

    val state by controller.state.collectAsState()
    Box(modifier = modifier) {
        TileMapView(
            modifier = Modifier.fillMaxSize(),
            center = state.camera.center,
            zoom = currentZoom,
            markers = state.markers,

            polylines = state.polylines,
            commands = controller.commands,
            onZoomChanged = { currentZoom = it }
        )
        ZoomButtons(
            modifier = Modifier
                .align(Alignment.BottomEnd)
                .padding(end = 12.dp, bottom = 24.dp),
            onZoomIn = { controller.zoomIn() },
            onZoomOut = { controller.zoomOut() },
            currentZoom = currentZoom
        )
    }
}
